import "core-js/stable";
import "regenerator-runtime/runtime";
import { setupClient } from "./auth/oidc";
import { initialConfigs } from "./configs/initialConfig";

initialConfigs().then((configs: { clientId: string }) => {
  const client = setupClient(configs.clientId);
  client
    .handleAuthentication()
    .then(async ({ shouldRender, state }) => {
      if (state?.finalRedirectUri) {
        location.href = state.finalRedirectUri;
      } else if (shouldRender) {
        import("./app").then(({ buildApp }) => buildApp());
      }
    })
    .catch(async (err) => {
      console.log(err);
      client.logout();
    });
});